import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminInviteAccept = lazy(() => import("@/pages/AdminInviteAccept"));

export const Route = createFileRoute("/invite")({
  component: AdminInviteAccept,
});
